import { render, staticRenderFns } from "./RechazoObserRechazo.vue?vue&type=template&id=2846df3a&"
import script from "./RechazoObserRechazo.vue?vue&type=script&lang=js&"
export * from "./RechazoObserRechazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports